import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import FormField from '../../components/FormField';
import { filterNonGuestUsers } from 'utils/users';
import { Typography, Tooltip, Link, ClickAwayListener } from '@material-ui/core';
import { setSeatsQuantity, setLicensesQuantity } from 'redux/modules/app';
import { isValidNonZeroQuantity } from '../../utils/subscription';
import { QUANTITY_TYPE, PLAN_CATEGORIES } from '../../config';
import i18n from 'i18n/i18n';
import { trackQuantityChange } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';
import { showModal } from '../../redux/modules/modal';
const localize = i18n.loc.localize;

const styles = theme => ({
	quantityFieldContainer: {
		display: 'flex',
		marginBottom: 15
	},
	itemsQuantityLabel: {
		display: 'flex',
		textTransform: 'uppercase',
		paddingTop: 10,
		fontWeight: 600,
		paddingRight: 10,
		opacity: 1,
		fontSize: 15,
		color: '#000',
	},
	itemsQuantityModalLabel: {
		textTransform: 'none',
		fontSize: 16,
		fontWeight: 'normal',
		paddingTop: 8
	},
	quantityField: {
		width: 72,
		'& [id*=helper-text]': {
			padding: '0 0 10px',
			whiteSpace: 'nowrap'
		}		
	},
	columnItemsQuantityInputRoot: {
	},
	textInput: {
		margin: 0,

		'& input': {
			borderWidth: 1,
			borderStyle: 'solid',
			borderRadius: 5,
			borderColor: theme.palette.secondary.lighter,
			color: theme.palette.text.primary,
			padding: '7px 10px',

			'&:focus': {
				borderColor: theme.palette.primary.main
			},

			'&::placeholder': {
				fontFamily: 'Open Sans, sans-serif',
				fontWeight: 'normal',
				fontStyle: 'normal',
				fontSize: '14px',
				lineHeight: '19px',
				color: theme.palette.text.primary
			}
		}
	},
	reminderMesesage: {
		fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
		fontWeight: 'normal',
		fontSize: 14,
		lineHeight: 1.5,
		opacity: 1,
		padding: '8px 0 0 10px',
		display: 'inline-block'
	},
	/* discount tooltip */
	arrow: {
		position: 'absolute',
		fontSize: 6,
		width: '3em',
		height: '1em',
		top: 0,
		left: '50%',
		transform: 'translateX(-50%)',
		marginTop: '-0.95em',
		'&::before': {
			content: '""',
			margin: 'auto',
			display: 'block',
			width: 0,
			height: 0,
			borderStyle: 'solid',
			borderWidth: '0 1em 1em 1em',
			borderColor: `transparent transparent ${theme.palette.common.black} transparent`,
		}
	},
	infoTooltip: {
		padding: 7,
		backgroundColor: theme.palette.common.black
	},
	infoTooltipText: {
		color: theme.palette.common.white,
		opacity: 1,
		pointerEvents: 'auto'
	},
	contactUsLink: {
		color: theme.palette.common.white,
		textDecoration: 'underline',
		opacity: 1,
		margin: '-3px 0 0'
	}
});

const SHOW_BULK_DISCOUNT_FOR_QUANTITY = 15;

@withStyles(styles)
class ItemsQuantityField extends Component {
	constructor(props) {
		super(props);

		this['input-product-quantity'] = React.createRef();
		this.handleBulkDiscountTooltipClose = this.handleBulkDiscountTooltipClose.bind(this);

		this.state = {
			itemsQuantity: this.props.quantity,
			itemsQuantityError: false,
			showBulkDiscountTooltip: props.enableBulkDiscountTooltip && props.quantity >= SHOW_BULK_DISCOUNT_FOR_QUANTITY
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.quantity !== nextProps.quantity) {
			this.setState({
				itemsQuantity: nextProps.quantity,
				showBulkDiscountTooltip: nextProps.quantity >= SHOW_BULK_DISCOUNT_FOR_QUANTITY &&
					nextProps.enableBulkDiscountTooltip
			});
		}		
	}

	componentDidMount() {
		this.validate(this.props.quantity);

		if (this.props.enableBulkDiscountTooltip) {
			window.addEventListener('resize', this.handleBulkDiscountTooltipClose);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleBulkDiscountTooltipClose);
	}	

	render() {
		const { classes } = this.props;
		const errorClasses = { root: classes.columnItemsQuantityInputRoot, error: classes.error };

		let labelKey;
		if (this.props.isBuyMorePopup) {
			if (this.props.quantityType == QUANTITY_TYPE.LICENSES) {
				labelKey = 'subscription-extra-licenses-quantity-label';
			} else if (this.props.quantityType == QUANTITY_TYPE.SEATS) {
				labelKey = 'subscription-extra-users-quantity-label';
			}
		} else if (this.props.isPerpetualOverviewMode) {
			labelKey = 'product-quantity-licenses-label';
		} else {
			labelKey = 'product-quantity-users-label';
		}

		let tooltipKey, tooltipPlan;
		if (this.props.isPerpetualOverviewMode || this.props.quantityType == QUANTITY_TYPE.LICENSES) {
			tooltipKey = 'perpetual';
		} else if (this.props.isBuyMorePopup && this.props.quantityType == QUANTITY_TYPE.SEATS) {
			tooltipPlan = this.props.plan;
		} else if (this.props.category === PLAN_CATEGORIES.CREATIVE_TOOLS) {
			// shows under Creative tools
			tooltipKey = 'desktop-plus-extended';
		}

		const getFormField = () => (<FormField
			value={this.state.itemsQuantity}
			autoComplete='off'
			className={classNames(classes.quantityField, classes.textInput)}
			data-tid={'input-product-quantity'}
			onChange={event => this.onQuantityChange(event)}
			onFocus={event => this.onFieldFocus(event)}
			onClick={event => this.onFieldFocus(event)}
			onKeyPress={event => this.onQuantityKeyPress(event)}
			id={'input-product-quantity'}
			margin="normal"
			helperText={this.state.itemsQuantityError}
			error={!!this.state.itemsQuantityError}
			FormHelperTextProps={{ classes: errorClasses }}
			inputRef={this['input-product-quantity']}
		/>);

		const renderQuantityField = () => {
			if (this.props.enableBulkDiscountTooltip) {
				return (
					<ClickAwayListener onClickAway={this.handleBulkDiscountTooltipClose}>
						<Tooltip
							placement="bottom"
							open={this.state.showBulkDiscountTooltip}
							title={
								<Fragment>
									<Typography variant='body2' className={classNames(classes.infoTooltipText)}>
										{localize('subscription-need-a-bulk-discount')}&nbsp;
										<Link
											component="button"
											variant="body2"
											data-tid='bulk-discount-button'
											className={classNames(classes.contactUsLink)}
											onClick={() => this.props.showModal('CONTACT_SALES_MODAL', {
												title: localize('contact-sales-form-title-bulk-discount')
											})}
										>
											{localize('subscription-contact-sales')} 
										</Link>
									</Typography>
									<span className={classes.arrow} />
								</Fragment>
							}
							classes={{
								tooltip: classes.infoTooltip
							}}
						>
							{getFormField()}
						</Tooltip>
					</ClickAwayListener>
				);
			} else {
				return getFormField();
			}
		};

		return (
			<div className={classes.quantityFieldContainer}>
				<Typography
					variant='body2'
					className={classNames(
						classes.itemsQuantityLabel,
						this.props.isBuyMorePopup
							?
							classes.itemsQuantityModalLabel
							:
							null)}>
					{localize(labelKey)}
				</Typography>

				{renderQuantityField()}

				{this.props.renderInfoTooltip(tooltipKey, true, tooltipPlan)}
				{!this.props.isBuyMorePopup && this.props.quantityType == QUANTITY_TYPE.SEATS && this.renderUserNumberReminder()}
			</div>
		);
	}

	handleBulkDiscountTooltipClose() {
		if (this.state.showBulkDiscountTooltip) {
			this.setState({
				showBulkDiscountTooltip: false
			});
		}
	}

	onFieldFocus() {
		this.setState({
			showBulkDiscountTooltip: this.props.enableBulkDiscountTooltip &&
				this.state.itemsQuantity >= SHOW_BULK_DISCOUNT_FOR_QUANTITY
		});
	}

	renderUserNumberReminder() {
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		const { classes } = this.props;

		if (this.state.itemsQuantity < nonGuestUsers.length) {
			return (
				<Typography
					className={classes.reminderMesesage}
				>
					{localize('product-quantity-numbers-of-users-reminder', nonGuestUsers.length)}
				</Typography>				
			);			
		}
	}

	onQuantityChange(event) {
		if (this.props.quantityType === QUANTITY_TYPE.LICENSES) {
			this.props.setLicensesQuantity(event.target.value);	
		} else {
			this.props.setSeatsQuantity(event.target.value);
		}

		this.validate(event.target.value);
	}

	validate(value) {
		if (isValidNonZeroQuantity(value)) {
			this.setState({
				itemsQuantityError: false
			});
		} else {
			this.setState({
				itemsQuantityError: localize('product-quantity-error')
			});
		}		
	}

	onQuantityKeyPress(event) {
		if (event.key === 'Enter') return;
		if (this.state.itemsQuantity !== 1) {
			setTimeout(() => {
				trackQuantityChange(
					this.props.quantityType,
					this['input-product-quantity'].current && this['input-product-quantity'].current.value,
					getTrackingOptions(this.props.company)
				);
			}, 250);
		}
	}
}

ItemsQuantityField.propTypes = {
	company: PropTypes.object,
	classes: PropTypes.object,
	quantity: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	plan: PropTypes.string,
	quantityType: PropTypes.string,
	setSeatsQuantity: PropTypes.func,
	setLicensesQuantity: PropTypes.func,
	renderInfoTooltip: PropTypes.func,
	isPerpetualOverviewMode: PropTypes.bool,
	isBuyMorePopup: PropTypes.bool,
	category: PropTypes.string,
	enableBulkDiscountTooltip: PropTypes.bool,
	showModal: PropTypes.func,
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId]
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setSeatsQuantity,
	setLicensesQuantity,
	showModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ItemsQuantityField);


// WEBPACK FOOTER //
// ./src/components/QuantityField/index.js